import React from 'react'

import { createValidIcon } from '@ui/icons/utils/type-helper'

import styles from './Card.module.scss'

export const CartesBancairesCard = createValidIcon(() => {
  return (
    <svg
      className={styles.cardShadow}
      width='36'
      height='24'
      viewBox='0 0 36 24'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
    >
      <rect width='36' height='24' rx='4' fill='url(#paint0_linear_8607_5711)' />
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M13.2167 11.5768H18.4521C18.4055 10.3643 18.1418 9.11421 17.3421 8.31129C16.3895 7.35479 14.7209 7 13.2299 7C11.6781 7 9.962 7.38914 9.00433 8.41536C8.17853 9.29943 8 10.7218 8 11.9997C8 13.3384 8.34927 14.8954 9.24513 15.7924C10.1977 16.7466 11.7413 17 13.2299 17C14.6761 17 16.2425 16.7139 17.1896 15.8079C18.134 14.9029 18.4604 13.3786 18.4604 11.9997V11.9933H13.2167V11.5768ZM18.8035 11.9935V16.7764H26.0865V16.7699C27.1522 16.7077 28 15.6782 28 14.4142C28 13.1496 27.1522 12.0541 26.0865 11.9914V11.9935H18.8035ZM26.0036 7.20029C27.0423 7.20029 27.8667 8.16586 27.8667 9.38429C27.8667 10.5377 27.1095 11.4797 26.1464 11.5769H18.8034V7.19329H25.7738C25.8167 7.18764 25.8667 7.19164 25.9155 7.1955C25.946 7.19786 25.976 7.20029 26.0036 7.20029Z'
        fill='#FEFEFE'
      />
      <defs>
        <linearGradient
          id='paint0_linear_8607_5711'
          x1='-0.315841'
          y1='1.74354'
          x2='36.667'
          y2='20.4543'
          gradientUnits='userSpaceOnUse'
        >
          <stop offset='0.13819' stopColor='#0D337A' />
          <stop offset='0.355769' stopColor='#509BCF' />
          <stop offset='0.471154' stopColor='#D0C4CF' />
          <stop offset='0.617836' stopColor='#E17163' />
          <stop offset='0.855574' stopColor='#CF061D' />
        </linearGradient>
      </defs>
    </svg>
  )
})
